import React from 'react';
import { Button } from './ui/button';

export default function EmptyState({ title, description, icon: Icon, action }) {
  return (
    <div className="rounded-xl border border-dashed border-border bg-card p-8 text-left" data-testid="empty-state">
      <div className="flex items-start gap-4">
        {Icon && (
          <div className="h-10 w-10 rounded-lg bg-muted grid place-items-center text-foreground/70">
            <Icon className="h-5 w-5" />
          </div>
        )}
        <div className="flex-1">
          <div className="text-sm font-semibold">{title}</div>
          {description && <div className="mt-1 text-sm text-muted-foreground max-w-[60ch]">{description}</div>}
          {action && (
            <Button className="mt-4" onClick={action.onClick} data-testid="empty-state-cta-button">
              {action.label}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
